exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FindWrongExercise-module__options___1MGMb{display:grid;grid-template-columns:repeat(4,250px);gap:1.5em}", ""]);

// exports
exports.locals = {
	"options": "FindWrongExercise-module__options___1MGMb"
};